var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.panelconfig.panel !== undefined)?_c(_vm.panelconfig.panel + 'Config',_vm._b({tag:"component"},'component',{panelconfig: _vm.panelconfig, },false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }